import React, { useEffect, useMemo, useState } from "react";

import { useResizeDetector } from "react-resize-detector";
import TreeViewMenu from "./TreeViewMenu";
import IconMenu from "./IconMenu";

import useStore from "../../../store";

/* eslint-disable-next-line no-undef */
const onBrowser = _isBrowser;

export default function MenuLeft() {
    const { width: menuWidth, ref: menuRef } = useResizeDetector();
    const isCollapsed = useStore((store) => store.menu.isCollapsed);
    const isHelpDesk = useStore((store) => store.app.appInfo.is_helpdesk);
    const title = useStore((store) => store.app.appInfo.title);
    const entries = useStore((store) => store.menu.entries);
    const setWidth = useStore((store) => store.menu.setWidth);
    const appInfo = useStore((store) => store.app.appInfo);
    const [bottomMenu, setBottomMenu] = useState([]);

    const showName = useStore((store) => store.app.userInfo.show_name);

    // const bottomMenu = ;

    // console.log(bottomMenu);

    // const contextAction = (action) => {
    //     // console.log(action);
    //     if (action === "addWidget") {
    //         setAddWidgetDialogOpen(true);
    //     } else if (action === "dashboardSelection") {
    //         setDashboardSelectionOpen(true);
    //     }
    // };

    useEffect(() => {
        if (entries.bottom) {
            const showNameChildren = [];

            if (!isHelpDesk) {
                showNameChildren.push({
                    id: 4,
                    display: "Widget hinzufügen",
                    action: "addWidget",
                    icon: "plus-square",
                });

                showNameChildren.push({
                    id: 5,
                    display: "Mein Account",
                    icon: "user",
                    tab: "MyAccount",
                // href: "/myself",
                });

                if (appInfo.notifications_enabled) {
                    showNameChildren.push({
                        id: 6,
                        display: "Benachrichtigungen",
                        icon: "comment-dots",
                        tab: "Notifications",
                    });
                }
            }
            if (entries.showName && entries.showName.length > 0) {
                entries.showName.forEach((item) => {
                    showNameChildren.push(item);
                });
            }

            // alphabetically sort subMenus of showName entry in bottom menu
            showNameChildren.sort((a, b) => a.display.localeCompare(b.display));

            setBottomMenu([
                {
                    id: 1,
                    display: "Benachrichtigungen",
                    icon: "comment",
                    action: "openNotifications",
                },
                ...showNameChildren.length > 0 ? [
                    {
                        id: 2,
                        display: showName,
                        icon: "user",
                        children: showNameChildren,
                    },
                ] : [],
                {
                    id: 7,
                    display: `Über ${title}`,
                    // eslint-disable-next-line no-underscore-dangle
                    image: appInfo.custom_icon_enabled && appInfo.__custom_icon_exists ? "./public/assets/custom_icon/pti.png" : "./static/pti.png",
                    // action: "openAbout",
                    children: [
                        {
                            id: 9,
                            display: `Über ${title}`,
                            icon: "info",
                            action: "openAbout",
                        },
                        {
                            id: 10,
                            display: "Changelogs",
                            icon: "book",
                            tab: "ChangelogHistory",
                        },
                    ],
                },
                ...entries.bottom,
                {
                    id: 8,
                    display: "Abmelden",
                    icon: "sign-out-alt",
                    action: "logout",
                },
            ]);
        }
    }, [entries, showName]);

    useEffect(() => {
        setWidth(menuWidth);
    }, [menuWidth]);

    return (
        useMemo(() => (
            <div
                ref={menuRef}
                style={{ height: `calc(100% - ${onBrowser ? "30px" : "40px"})`, borderRight: "1px solid" }}
            >
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                        {
                            !onBrowser
                            && <div style={{ marginTop: isCollapsed ? "12px" : "20px" }} />
                        }
                        {isCollapsed ? (
                            <IconMenu
                                menu={entries.top || []}
                                bottomMenu={bottomMenu}
                            />
                        ) : (
                            <TreeViewMenu
                                menu={entries.top || []}
                                bottomMenu={bottomMenu}
                            />
                        )}
                    </div>
                </div>
            </div>
        ), [isCollapsed, entries, bottomMenu])
    );
}
